import { createContext, useContext } from "react";

import type { FormEntityListboxContextValue } from "./types";

export const FormEntityListboxContext = createContext<FormEntityListboxContextValue | null>(null);

export function useFormEntityListbox(): FormEntityListboxContextValue {
	const ctx = useContext(FormEntityListboxContext);
	return ctx ?? {
		activeTable: null,
		activeScreenLocation: null,
		drillDownOpen: false,
		subPanelTitle: "",
		filteredSubFields: [],
		fieldCategory: "simpleVariable",
		subPanelLoading: false,
		subPanelError: false,
		searchQuery: "",
		selectedValue: "",
		onBack: () => {},
		onFieldSelect: () => {},
	};
}
